import { Link } from 'react-router-dom';
import { Section, Media, Video, Step } from '../ui';
import { DETECTIONS } from '../content';

export default function Vision() {
  return (
    <main>
      <Section lg>
        <div className="split">
          <div>
            <Link className="eyebrow" to="/services" style={{ textTransform: 'uppercase' }}>
              Services &#65295; AI and Machine Learning
            </Link>
            <h1 className="h-page" style={{ fontSize: 'clamp(36px, 5vw, 64px)' }}>
              Visual Intelligence
            </h1>
            <p className="lede">
              Computer vision and AI that identify, classify, track, and inspect objects and
              conditions in imagery. Models are built around the operational challenge, not the
              other way around.
            </p>
          </div>
          <Video
            src="/assets/ai-circuit.mp4"
            poster="/assets/ai-circuit-poster.jpg"
            alt="Circuit substrate animating as data moves through it"
            ratio="4x3"
            ticked={false}
            priority
          />
        </div>
      </Section>

      <Section>
        <div className="sec-head">
          <h2 className="h-sub">Detection examples</h2>
          <span className="eyebrow">Live model output</span>
        </div>
        <div className="grid-plain" style={{ '--min': '280px' }}>
          {DETECTIONS.map((d) => (
            <figure key={d.title}>
              <Video src={d.video} poster={d.poster} alt={d.alt} ratio="4x3" caption={d.frame} />
              <figcaption className="figcap">
                <span className="figcap__t">{d.title}</span>
                <span className="figcap__m">{d.meta}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </Section>

      <Section alt>
        <h2 className="h-sub" style={{ marginBottom: 40 }}>
          From pixels to decisions
        </h2>
        <div className="grid-plain" style={{ '--min': '200px', gap: 24 }}>
          <Step n="01" title="Annotate">
            Label real captures against the conditions your inspectors care about.
          </Step>
          <Step n="02" title="Train">
            Build and tune models on your imagery, not a generic dataset.
          </Step>
          <Step n="03" title="Evaluate">
            Measure precision and recall against inspector-reviewed ground truth.
          </Step>
          <Step n="04" title="Deploy">
            Deliver findings into the review and reporting tools already in use.
          </Step>
        </div>
      </Section>

      <Section>
        <div className="split">
          <div>
            <span className="eyebrow">Built for real-world conditions</span>
            <h2 className="h-sub" style={{ margin: '16px 0 20px' }}>
              A model is not the whole job.
            </h2>
            <p className="body" style={{ fontSize: 16, marginBottom: 20 }}>
              Real-world AI requires more than a model. Wanda develops and evaluates solutions
              around the data, conditions, and workflows where they will actually be used.
            </p>
            <p className="body" style={{ fontSize: 16, color: 'var(--text-body)' }}>
              Already have imagery, training data, or a model? We can start there.
            </p>
          </div>
          <Media
            src="/assets/ai-code.jpg"
            alt="Image-processing source code on a developer display"
            ratio="4x3"
            ticked={false}
          />
        </div>
      </Section>
    </main>
  );
}
